import { UUIDString } from "../Types";

export enum AutomationVendorTaskType {
  OPT_OUT = "OPT_OUT",
  DELETE = "DELETE",
  LOOKUP = "LOOKUP",
}

export enum AutomationVendorTaskStatus {
  SENT = "SENT",
  FAILED = "FAILED",
  SUCCEEDED = "SUCCEEDED",
}

export enum VendorOutcomeValue {
  AUTOMATION_CONFIRMED = "AUTOMATION_CONFIRMED",
  AUTOMATION_REQUESTED = "AUTOMATION_REQUESTED",
  AUTOMATION_FAILED = "AUTOMATION_FAILED",
  AUTOMATION_NO_DATA = "AUTOMATION_NO_DATA",
}

export interface AutomationVendorTaskDto {
  id: UUIDString;
  createdAt: string; // ISO date string
  resolvedAt?: string;
  requestType?: AutomationVendorTaskType;
  dataRecipientIntegrationName?: string;
  dataRecipientName?: string;
  dataRecipientLogoFilename?: string;
  status: AutomationVendorTaskStatus;
  statusMessage?: string;
  vendorOutcome?: VendorOutcomeValue;
  vendorFlagConsumerFound?: boolean;
  dataRequestId?: UUIDString;
  dataRequestPublicId?: string;
  consumerName?: string;
  dataRequestState?: string;
  dataRequestClosedAt?: string;
  isBatched: boolean;
  batchRepresentativeRequestPublicId?: string;
  responseBody?: string;
}
